export const RECAPTCHA_SITE_KEY = process.env.VUE_APP_RECAPTCHA_SITE_KEY;



// WEBPACK FOOTER //
// ./src/config/_recaptcha.js